module.exports = __webpack_public_path__ + "static/media/free-post.2693cc13.png";